import { render } from "./TextBox.vue?vue&type=template&id=13620700&scoped=true"
import script from "./TextBox.vue?vue&type=script&lang=js"
export * from "./TextBox.vue?vue&type=script&lang=js"

import "./TextBox.vue?vue&type=style&index=0&id=13620700&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13620700"]])

export default __exports__